export enum VideoProvider {
  APA = 'APA',
  VIMEO = 'VIMEO',
}

export interface TtComVideoPlaylist {
  videos: TtComVideo[];
  take: number;
  from: number;
  count: number;
}
export interface TtComVideo {
  id: string;
  provider: VideoProvider;
  embedUrl: string;
  title: string;
  description: string;
  timestamp: string;
  duration: number;
  tags: TtComVideoTag[];
  pictureBaseUrl: string;
  pictures: TtComVideoPicture[];
}

export interface TtComVideoPicture {
  url: string;
  width: number;
  height: number;
}

export interface TtComVideoTag {
  tag: string;
  canonical: string;
}
